module.exports = __webpack_public_path__ + "img/blog-cv-6.faac3a06.webp";